import { HealthMetricValueV3Isolate } from '#components/charts/core/range-graph/utils/use-health-metric-values.ts';
import type {
  MasonryChartDataPoint,
  MasonryChartDataPointType,
} from '#types/masonry-chart.type.ts';

/**
 * An adapter function to convert the data from the MasonryChart format
 * to the format used by the HealthMetricValueV3Isolate.
 */
export function convertMasonryChartToHealthMetricData(
  dataset: MasonryChartDataPoint[],
  dataPointTypes: MasonryChartDataPointType[],
) {
  const dataPointTypeMap = new Map(
    dataPointTypes.map((dataPointType) => [dataPointType.id, dataPointType]),
  );
  const chartData: HealthMetricValueV3Isolate[] = dataset.map((dataPoint) => {
    const metricComponent = dataPointTypeMap.get(dataPoint.dataPointType)!;
    const { unit } = metricComponent;

    return {
      timestamp: dataPoint.timestamp,
      value: dataPoint.value ?? null,
      label: dataPoint.label ?? '',
      aggregationStrategyLabel: dataPoint.aggregationStrategyLabel,
      indicator: dataPoint.indicator,
      metricComponent: {
        data: {
          ...metricComponent,
          unit: unit
            ? {
                ...unit,
                symbol: unit.symbol ?? null,
              }
            : undefined,
        },
      },
    };
  });
  return chartData;
}
